import { t, getLang, setLang, toggleLang, applyDOMTranslations } from "./i18n.js";

let modalEl = null;
let currentTab = "about"; // "about" | "guide" | "contact"

export function createAboutModal() {
  if (modalEl) return;

  modalEl = document.createElement("div");
  modalEl.id = "aboutModal";
  modalEl.className = "modalBackdrop hidden";

  modalEl.innerHTML = `
    <div class="modalCard">
      <div class="modalHeader">
        <div class="modalHeaderLeft">
          <img src="/logo_starcode.png" alt="STARCODE" class="modalLogoSmall" />
          <h2 class="modalTitle" data-i18n="aboutModalTitle">${t("aboutModalTitle")}</h2>
        </div>
        <div class="modalHeaderRight">
          <div class="langSwitchModal">
            <button type="button" class="langBtn ${getLang() === "de" ? "active" : ""}" data-lang="de">DE</button>
            <span class="langSep">/</span>
            <button type="button" class="langBtn ${getLang() === "en" ? "active" : ""}" data-lang="en">EN</button>
          </div>
          <button type="button" class="modalCloseBtn" aria-label="Close" title="Schließen / Close">✕</button>
        </div>
      </div>

      <div class="modalTabs">
        <button type="button" class="modalTab active" data-tab="about" data-i18n="tabAbout">${t("tabAbout")}</button>
        <button type="button" class="modalTab" data-tab="guide" data-i18n="tabGuide">${t("tabGuide")}</button>
        <button type="button" class="modalTab" data-tab="contact" data-i18n="tabContact">${t("tabContact")}</button>
      </div>

      <div class="modalBody">
        <!-- Tab 1: About Project -->
        <div class="tabPane tabPaneAbout active">
          <p class="modalIntro" data-i18n="aboutText1">${t("aboutText1")}</p>
          <p class="modalDesc" data-i18n="aboutText2">${t("aboutText2")}</p>
          
          <div class="featureGrid">
            <div class="featureCard">
              <div class="featureIcon">⚡</div>
              <div class="featureText">
                <h4 data-i18n="aboutFeature1Title">${t("aboutFeature1Title")}</h4>
                <p data-i18n="aboutFeature1Desc">${t("aboutFeature1Desc")}</p>
              </div>
            </div>
            <div class="featureCard">
              <div class="featureIcon">⧉</div>
              <div class="featureText">
                <h4 data-i18n="aboutFeature2Title">${t("aboutFeature2Title")}</h4>
                <p data-i18n="aboutFeature2Desc">${t("aboutFeature2Desc")}</p>
              </div>
            </div>
            <div class="featureCard">
              <div class="featureIcon">🎥</div>
              <div class="featureText">
                <h4 data-i18n="aboutFeature3Title">${t("aboutFeature3Title")}</h4>
                <p data-i18n="aboutFeature3Desc">${t("aboutFeature3Desc")}</p>
              </div>
            </div>
          </div>
        </div>

        <!-- Tab 2: Tutorial & Resolume VJ Guide -->
        <div class="tabPane tabPaneGuide">
          <div class="guideSection">
            <h3 class="guideSectionHeader" data-i18n="guideNavTitle">${t("guideNavTitle")}</h3>
            <p class="guideSectionIntro" data-i18n="guideNavDesc">${t("guideNavDesc")}</p>
            <div class="guideShortcutGrid">
              <div class="guideShortcutCard">
                <div class="guideKeyBadge"><span class="mouseIcon">🖱️</span> Drag</div>
                <div class="guideShortcutText">
                  <strong data-i18n="guideNavOrbit">${t("guideNavOrbit")}</strong>
                  <span data-i18n="guideNavOrbitDesc">${t("guideNavOrbitDesc")}</span>
                </div>
              </div>
              <div class="guideShortcutCard">
                <div class="guideKeyBadge"><kbd>1</kbd> + Drag</div>
                <div class="guideShortcutText">
                  <strong data-i18n="guideNavPan">${t("guideNavPan")}</strong>
                  <span data-i18n="guideNavPanDesc">${t("guideNavPanDesc")}</span>
                </div>
              </div>
              <div class="guideShortcutCard">
                <div class="guideKeyBadge"><kbd>2</kbd> + Drag</div>
                <div class="guideShortcutText">
                  <strong data-i18n="guideNavZoom">${t("guideNavZoom")}</strong>
                  <span data-i18n="guideNavZoomDesc">${t("guideNavZoomDesc")}</span>
                </div>
              </div>
              <div class="guideShortcutCard">
                <div class="guideKeyBadge"><kbd>3</kbd> + Drag</div>
                <div class="guideShortcutText">
                  <strong data-i18n="guideNavSpin">${t("guideNavSpin")}</strong>
                  <span data-i18n="guideNavSpinDesc">${t("guideNavSpinDesc")}</span>
                </div>
              </div>
            </div>
          </div>

          <div class="guideSection">
            <h3 class="guideSectionHeader" data-i18n="guideVJTitle">${t("guideVJTitle")}</h3>
            <p class="guideSectionIntro" data-i18n="guideVJDesc">${t("guideVJDesc")}</p>
            
            <div class="guideStepCard">
              <div class="guideStepNum">1</div>
              <div class="guideStepContent">
                <h4 data-i18n="guideVJStep1Title">${t("guideVJStep1Title")}</h4>
                <p data-i18n="guideVJStep1Desc">${t("guideVJStep1Desc")}</p>
              </div>
            </div>

            <div class="guideStepCard">
              <div class="guideStepNum">2</div>
              <div class="guideStepContent">
                <h4 data-i18n="guideVJStep2Title">${t("guideVJStep2Title")}</h4>
                <p data-i18n="guideVJStep2Desc">${t("guideVJStep2Desc")}</p>
              </div>
            </div>

            <div class="guideStepCard">
              <div class="guideStepNum">3</div>
              <div class="guideStepContent">
                <h4 data-i18n="guideVJStep3Title">${t("guideVJStep3Title")}</h4>
                <p data-i18n="guideVJStep3Desc">${t("guideVJStep3Desc")}</p>
              </div>
            </div>
          </div>

          <div class="guideSection">
            <h3 class="guideSectionHeader" data-i18n="guideFormzTitle">${t("guideFormzTitle")}</h3>
            <p class="guideSectionIntro" data-i18n="guideFormzDesc">${t("guideFormzDesc")}</p>
            
            <div class="guideFeatureList">
              <div class="guideFeatureItem">
                <span class="guideBullet">🌀</span>
                <div>
                  <strong data-i18n="guideBlackHoleTitle">${t("guideBlackHoleTitle")}</strong>
                  <span data-i18n="guideBlackHoleDesc">${t("guideBlackHoleDesc")}</span>
                </div>
              </div>
              <div class="guideFeatureItem">
                <span class="guideBullet">⚡</span>
                <div>
                  <strong data-i18n="guideNeutronTitle">${t("guideNeutronTitle")}</strong>
                  <span data-i18n="guideNeutronDesc">${t("guideNeutronDesc")}</span>
                </div>
              </div>
              <div class="guideFeatureItem">
                <span class="guideBullet">☀️</span>
                <div>
                  <strong data-i18n="guideSunTitle">${t("guideSunTitle")}</strong>
                  <span data-i18n="guideSunDesc">${t("guideSunDesc")}</span>
                </div>
              </div>
              <div class="guideFeatureItem">
                <span class="guideBullet">💎</span>
                <div>
                  <strong data-i18n="guideMorphTitle">${t("guideMorphTitle")}</strong>
                  <span data-i18n="guideMorphDesc">${t("guideMorphDesc")}</span>
                </div>
              </div>
            </div>
          </div>

          <div class="guideSection">
            <h3 class="guideSectionHeader" data-i18n="guideOpticsTitle">${t("guideOpticsTitle")}</h3>
            <div class="guideOpticsBox">
              <p data-i18n="guideOpticsDesc">${t("guideOpticsDesc")}</p>
            </div>
          </div>
        </div>

        <!-- Tab 3: Creator & Contact -->
        <div class="tabPane tabPaneContact">
          <div class="creatorProfile">
            <div class="creatorLogoWrap">
              <img src="/logo_studiopesc.webp" alt="STUDIO PESC Logo" class="creatorModalLogo" />
            </div>
            <div class="creatorInfo">
              <h3 class="creatorNameHeading">Peter Schönhardt</h3>
              <p class="creatorRoleText" data-i18n="creatorRole">${t("creatorRole")}</p>
              <div class="creatorTags">
                <span class="creatorTag">STUDIO PESC</span>
                <span class="creatorTag" data-i18n="creatorLocation">${t("creatorLocation")}</span>
              </div>
            </div>
          </div>

          <p class="creatorBioText" data-i18n="creatorBio">${t("creatorBio")}</p>

          <div class="contactLinks">
            <a href="https://studiopesc.com" target="_blank" rel="noopener noreferrer" class="contactLinkBtn">
              <span class="contactLinkIcon">🌐</span>
              <span class="contactLinkText">studiopesc.com</span>
              <span class="contactLinkArrow">↗</span>
            </a>
            <a href="mailto:peter@studiopesc.com" class="contactLinkBtn">
              <span class="contactLinkIcon">✉️</span>
              <span class="contactLinkText">peter@studiopesc.com</span>
              <span class="contactLinkArrow">↗</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  `;

  document.body.appendChild(modalEl);

  // Setup event listeners
  const closeBtn = modalEl.querySelector(".modalCloseBtn");
  closeBtn.addEventListener("click", hideAboutModal);
  modalEl.addEventListener("click", (e) => {
    if (e.target === modalEl) hideAboutModal();
  });

  // Tab switching
  const tabs = modalEl.querySelectorAll(".modalTab");
  tabs.forEach((tab) => {
    tab.addEventListener("click", () => {
      const target = tab.dataset.tab;
      currentTab = target;
      tabs.forEach((t) => t.classList.toggle("active", t === tab));
      modalEl.querySelector(".tabPaneAbout").classList.toggle("active", target === "about");
      modalEl.querySelector(".tabPaneGuide").classList.toggle("active", target === "guide");
      modalEl.querySelector(".tabPaneContact").classList.toggle("active", target === "contact");
    });
  });

  // Modal language buttons
  const langBtns = modalEl.querySelectorAll(".langBtn");
  langBtns.forEach((btn) => {
    btn.addEventListener("click", () => {
      setLang(btn.dataset.lang);
    });
  });

  // Listen to lang changes to re-render texts
  window.addEventListener("starcode:langchange", () => {
    updateModalLanguage();
  });
}

function updateModalLanguage() {
  if (!modalEl) return;
  applyDOMTranslations(modalEl);
}

export function showAboutModal(tab = "about") {
  if (!modalEl) createAboutModal();
  currentTab = tab;
  const tabs = modalEl.querySelectorAll(".modalTab");
  tabs.forEach((t) => t.classList.toggle("active", t.dataset.tab === tab));
  modalEl.querySelector(".tabPaneAbout").classList.toggle("active", tab === "about");
  modalEl.querySelector(".tabPaneGuide").classList.toggle("active", tab === "guide");
  modalEl.querySelector(".tabPaneContact").classList.toggle("active", tab === "contact");
  updateModalLanguage();
  modalEl.classList.remove("hidden");
}

export function hideAboutModal() {
  if (modalEl) modalEl.classList.add("hidden");
}
